/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import 'contents/assets/scss/page/promotion.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import PopCallStatus from './_PopCallStatus';

const InboundTeam = () => {
  const navigate = useNavigate();
  const {tabNumber} = useParams();
  const [modalCallStatus, setModalCallStatus] = useState(false);
  const [tabIdx, setTabIdx] = useState(Number(tabNumber) || 0);
  const tab = [
    {title: '상담대기', value: 0},
    {title: '인바운드', value: 1, type: 'bar'},
    {title: '진행중인 상담', value: 2},
    {title: '종료 상담', value: 3},
    {title: '성공 상담', value: 4, type: 'bar'},
    {title: '전화번호 정보 검색', value: 5, type: 'bar'},
    {title: '내 통계', value: 6}
  ];
  return (
    <main className="com_container p_inboun_team">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_4">
            홍보하기<span className="bar"></span>
            <span className="point_txt">김홍보103</span>
          </h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            {tabIdx === 0 && (
              <>
                <div className="table_container">
                  <table className="com_board_list">
                    <colgroup>
                      <col width="70" />
                      <col width="220" />
                      <col width="220" />
                      <col width="220" />
                      <col width="220" />
                      <col width="auto" />
                      <col width="210" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>구분</th>
                        <th>이름</th>
                        <th>학년</th>
                        <th>희망 시간</th>
                        <th>수신일</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>이지수능교육</td>
                        <td>양경찬(학부모)</td>
                        <td>고1</td>
                        <td>상시가능</td>
                        <td>
                          1시간 37분 전<br /> (2024년 3월 12일(화) 오후 6시 3분)
                        </td>
                        <td>
                          <button
                            onClick={() => {
                              setModalCallStatus(true);
                            }}
                            className="com_btn gray s"
                          >
                            상담 가져오기
                          </button>
                        </td>
                      </tr>
                      {[...Array(8)].map((i, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>이지수능교육</td>
                          <td>양경찬(학부모)</td>
                          <td>고1</td>
                          <td>오후 06시 ~ 09시</td>
                          <td>
                            1시간 37분 전<br /> (2024년 3월 12일(화) 오후 6시 3분)
                          </td>
                          <td>
                            <button
                              onClick={() => {
                                setModalCallStatus(true);
                              }}
                              className="com_btn gray s"
                            >
                              상담 가져오기
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <Paging />
              </>
            )}
            {tabIdx === 1 && (
              <>
                <div className="table_container">
                  <table className="com_board_list">
                    <colgroup>
                      <col width="70" />
                      <col width="360" />
                      <col width="360" />
                      <col width="auto" />
                      <col width="360" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>전화번호</th>
                        <th>ERP별칭</th>
                        <th>수신일</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(8)].map((i, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>010-****-0227</td>
                          <td>김수현102</td>
                          <td>
                            1시간 37분 전<br /> (2024년 3월 12일(화) 오후 6시 3분)
                          </td>
                          <td>
                            <button
                              onClick={() => {
                                setModalCallStatus(true);
                              }}
                              className="com_btn gray s"
                            >
                              상담 가져오기
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <Paging />
              </>
            )}
            {tabIdx === 2 && (
              <>
                <hr className="com_divider" />
                <div className="com_board_list__top">
                  <section className="com_board_search">
                    <div className="date_wrap">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <span className="divider"> ~ </span>
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <select name="" id="" className="select">
                        <option value="">전체 상태</option>
                      </select>
                      <select name="" id="" className="select">
                        <option value="">전체 구분</option>
                      </select>
                      <select name="" id="" className="select">
                        <option value="">전체 학년</option>
                      </select>
                      <select name="" id="" className="select">
                        <option value="">통합검색</option>
                      </select>
                    </div>
                    <article className="search">
                      <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                      <button className="com_btn gray ws s icon_search"></button>
                    </article>
                  </section>

                  <select name="" id="" className="select wl">
                    <option value="">통화 우선순위 높은 순</option>
                  </select>
                </div>
                <div className="table_container">
                  <table className="com_board_list">
                    <colgroup>
                      <col width="70" />
                      <col width="200" />
                      <col width="200" />
                      <col width="200" />
                      <col width="200" />
                      <col width="200" />
                      <col width="200" />
                      <col width="auto" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>구분</th>
                        <th>상태</th>
                        <th>이름</th>
                        <th>학년</th>
                        <th>희망 시간</th>
                        <th>통화예정</th>
                        <th>등록일</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(8)].map((i, idx) => (
                        <tr key={idx} onClick={() => navigate('/Promotion/InboundTeam/Detail/2')}>
                          <td>{idx + 1}</td>
                          <td>이지수능교육</td>
                          <td>대기</td>
                          <td>양경찬(학부모)</td>
                          <td>고1</td>
                          <td>오후 06시 ~ 09시</td>
                          <td>즉시</td>
                          <td>1시간 37분 전<br /> (2024년 3월 12일(화) 오후 6시 3분) </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <Paging />
              </>
            )}
            {tabIdx === 3 && (
              <>
                <hr className="com_divider" />
                <div className="com_board_list__top">
                  <section className="com_board_search">
                    <div className="date_wrap">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <span className="divider"> ~ </span>
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <select name="" id="" className="select">
                        <option value="">전체 상태</option>
                      </select>
                      <select name="" id="" className="select">
                        <option value="">전체 구분</option>
                      </select>
                      <select name="" id="" className="select">
                        <option value="">전체 학년</option>
                      </select>
                      <select name="" id="" className="select">
                        <option value="">통합검색</option>
                      </select>
                    </div>
                    <article className="search">
                      <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                      <button className="com_btn gray ws s icon_search"></button>
                    </article>
                  </section>

                  <select name="" id="" className="select wl">
                    <option value="">최근 등록일 순</option>
                  </select>
                </div>
                <div className="table_container">
                  <table className="com_board_list">
                    <colgroup>
                      <col width="70" />
                      <col width="250" />
                      <col width="250" />
                      <col width="250" />
                      <col width="250" />
                      <col width="auto" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>구분</th>
                        <th>상태</th>
                        <th>이름</th>
                        <th>학년</th>
                        <th>등록일</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(8)].map((i, idx) => (
                        <tr key={idx} onClick={() => navigate('/Promotion/InboundTeam/Detail/3')}>
                          <td>{idx + 1}</td>
                          <td>이지수능교육</td>
                          <td> 대기</td>
                          <td>양경찬(학부모)</td>
                          <td>고1</td>
                          <td> 1시간 37분 전<br /> (2024년 3월 12일(화) 오후 6시 3분)</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <Paging />
              </>
            )}
            {tabIdx === 4 && (
              <>
                <hr className="com_divider" />
                <div className="com_board_list__top">
                  <section className="com_board_search">
                    <div className="date_wrap">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <span className="divider"> ~ </span>
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <select name="" id="" className="select">
                        <option value="">전체 상태</option>
                      </select>
                      <select name="" id="" className="select">
                        <option value="">전체 구분</option>
                      </select>
                      <select name="" id="" className="select">
                        <option value="">전체 학년</option>
                      </select>
                      <select name="" id="" className="select">
                        <option value="">통합검색</option>
                      </select>
                    </div>
                    <article className="search">
                      <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                      <button className="com_btn gray ws s icon_search"></button>
                    </article>
                  </section>

                  <select name="" id="" className="select wl">
                    <option value="">최근 등록일 순</option>
                  </select>
                </div>
                <div className="table_container">
                  <table className="com_board_list">
                    <colgroup>
                      <col width="70" />
                      <col width="250" />
                      <col width="250" />
                      <col width="250" />
                      <col width="250" />
                      <col width="auto" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>구분</th>
                        <th>상태</th>
                        <th>이름</th>
                        <th>학년</th>
                        <th>등록일</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(8)].map((i, idx) => (
                        <tr key={idx} onClick={() => navigate('/Promotion/InboundTeam/Detail/4')}>
                          <td>{idx + 1}</td>
                          <td>이지수능교육</td>
                          <td> 대기</td>
                          <td>양경찬(학부모)</td>
                          <td>고1</td>
                          <td>1시간 37분 전<br /> (2024년 3월 12일(화) 오후 6시 3분)</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <Paging />
              </>
            )}
            {tabIdx === 5 && (
              <>
                <hr className="com_divider" />
                <div className="com_board_list__top">
                  <section className="com_board_search end">
                    <article className="search">
                      <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                      <button className="com_btn gray ws s icon_search"></button>
                    </article>
                  </section>
                </div>
                이지측 개발 내용 그대로 ERP로 이전
              </>
            )}
          </section>
        </section>
      </div>
      <PopCallStatus open={modalCallStatus} close={() => setModalCallStatus(false)} />
    </main>
  );
};

export default InboundTeam;
